export default "__VITE_ASSET__DwvWEa$Q__"